import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

const initialState = null;

const setSelectedId = (_, { payload: auditModelId }) => auditModelId;

const reset = () => initialState;

export default createReducer(initialState, {
  [types.DISPLAY_TARGET_MODAL]: setSelectedId,
  [types.HIDE_TARGET_MODAL]: reset,
});
